import React from "react";
import { Text } from "react-native-paper";
import { FieldDisplayRendererProps } from "./types";

export const LocationDisplayRenderer = ({
  field,
  value,
}: FieldDisplayRendererProps) => {
  return (
    <Text>
      {`${field.label}: Latitude: ${value?.latitude ?? (typeof value === "object" && value !== null ? value.name || value.id || JSON.stringify(value) : "")}, Longitude: ${value?.longitude ?? (typeof value === "object" && value !== null ? value.name || value.id || JSON.stringify(value) : "")}`}
    </Text>
  );
};
